import React from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import { indexMap } from '@helpers'
import OptionalExtra from './OptionalExtra'
import './OptionalExtras.module.scss'

const renderExtras = (extras, { increment, decrement }) => indexMap((extra, index) => (
  <OptionalExtra
    extra={extra}
    key={index}
    increment={() => increment(index)}
    decrement={() => decrement(index)} />

), extras)

const OptionalExtras = ({ extras, increment, decrement }) => (
  <div styleName='optional-extras'>
    {R.not(R.isEmpty(extras)) && <h2>Select optional extras</h2>}
    <div styleName='wrapper'>
      {renderExtras(extras, { increment, decrement })}
    </div>
  </div>
)

OptionalExtras.propTypes = {
  extras: PropTypes.array,
  increment: PropTypes.func.isRequired,
  decrement: PropTypes.func.isRequired
}

OptionalExtras.defaultProps = {
  extras: []
}

export default OptionalExtras



// WEBPACK FOOTER //
// ./src/components/ProductSummary/OptionalExtras/OptionalExtras.js